import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { verifyGSTIN, clearGSTData } from "../../redux/slices/gstSlice";
import Loader from "../../components/Loader/Loader";
import "./companypage.css";

const Gstpage = () => {
  const [gst, setGst] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.gst);

    const handleProcess = async () => {
    if (!gst) {
    alert("Please enter a GST number.");
    return;
       }

      try {
      const result = await dispatch(verifyGSTIN(gst)).unwrap();
      if (result.success) {
        navigate("/gstformpage");
      } else {
        alert("Invalid GST Number. Please try again.");
      }
    } catch (err) {
      alert("Error verifying GST Number. Please try again later.");
    }
  };

  const handleNoGST = () => {
    dispatch(clearGSTData()); // Clear GST data so the form is empty
    navigate("/companyPage");
  };
   const handleNoGSTPending =()=>{
    navigate("/prevstatus")
   }

  return (
    <div>
      {loading && <Loader />}
      <div className="container mt-5">

         <div className="gstbox_card"> 
         <h6
          style={{color:"#34495e"}}
         ><strong>GST Number</strong></h6>
          <div className="input_track"> 
          <input
          type="text"
          className="form-control mt-2 mb-4 gst_input"
          placeholder="Enter GST Number"
          value={gst}
          onChange={(e) => setGst(e.target.value)}
        />
        </div>
       
          <div className="d-flex justify-content-center gap-3">
          <button className="btn btn-primary" onClick={handleProcess} disabled={loading}>
          {loading ? "Processing..." : "Process"}
          </button>

          <button className="btn gst_dt" onClick={handleNoGST}>
          Don’t have GST Number  
          </button>

        </div>
        {error && <p className="text-danger mt-3">{error}</p>}
          
         </div>
       
      </div>
    </div>
  );
};

export default Gstpage;
